import { useCallback } from 'react';
import { TrackingApi } from 'src/api';
import type { LearningSessionTooEasyForYouTrackingAction } from 'src/api/tracking/types';
import { useUserContext } from 'src/context/user';
import { getActiveWordlistId } from 'src/utils/wordlists/getActiveWordlistId';

export const useTrackTooEasyForYou = (
  languagePairId: number,
  trackingData?: Record<string, string>,
) => {
  const { user } = useUserContext();

  return useCallback(
    (action: LearningSessionTooEasyForYouTrackingAction) => {
      const wordlistId = getActiveWordlistId();
      void TrackingApi.trackUserAction(
        action,
        'learning_session_too_easy_for_you',
        languagePairId,
        !!user?.isPro,
        {
          ...trackingData,
          ...(wordlistId && { wordlist_id: wordlistId }),
        },
      );
    },
    [languagePairId, trackingData, user?.isPro],
  );
};
